import React from "react";
import { localized } from '../i18n/translations';
import Quantity from "../components/Quantity";
import { BrowserRouter, Routes, Route, Link, NavLink } from "react-router-dom"
import Footer from "../components/Footer";
import CustomImage from "../components/CustomImage";
import PriceDisplay from "../components/PriceDisplay";
import PriceDisplayWithCustomOption from "../components/PriceDisplayWithCustomOption";
import { formatCustomOptionDisplay } from "../components/customOptionUtils";
import { PET_ACCESSORIES, getCustomDataExtrasTotalPrice, getPetCount, getExtraPetsPrice, getAccessoryDescription, getAccessoryLabel } from "../components/petAccessoryUtils";
import { getCartLeadDays, formatLeadDates } from "../components/deliveryEstimate";

export default function Cart({ cartItems, ChangeQty, country, apiCountry, productsData, totalSubtotal, shippingInfo, shippingPrice, RemoveItemFromCart, currency, totalAmount, translate, categories }) {


  console.log(cartItems)

  const ItemsInCart = productsData.map(product => (
    cartItems.map(item => {
      if (item.id === product.id) {

        return (
          <div className=" mt-3 text-black items-center justify-start border-gray-400 pb-3 border-b" key={item.cartKey || product.id}>
            <div className="flex">
              <div className="w-36 flex-shrink-0">
                <CustomImage src={(item.setData?.image_index !== null && item.setData?.image_index !== undefined && product.listingImages?.[item.setData.image_index]) ? product.listingImages[item.setData.image_index] : product.imageUrl} alt={product.imageAlt} className="w-36" />
              </div>
              <div className="ml-2 flex flex-col flex-1 min-w-0">
                <div className="flex flex-col">
                  <div className="flex">
                    <span className="text-sm w-full">{localized(product, 'name', country)}{item.setData?.label && (
                      <span className="ml-1 text-xs text-gray-500">({item.setData.label})</span>
                    )}{item.customOption && (
                      <span className="ml-1 text-xs text-gray-900">({formatCustomOptionDisplay(product?.custom_options, item.customOption, country)})</span>
                    )}</span>
                    <button onClick={() => RemoveItemFromCart(item.cartKey || product.id)}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>

                  </div>
                  <PriceDisplayWithCustomOption product={product} currency={currency} customOption={item.customOption} selectedSet={item.setData} accessoriesModifier={getCustomDataExtrasTotalPrice(item.customData, currency)} className="text-sm" />
                </div>
                <div>
                  {(() => {
                    const isSetUnavailable = item.setData
                      ? !(item.setData.items || []).every(setItem => {
                          const p = productsData.find(pd => pd.id === setItem.product_id);
                          return p && p.available && p.is_in_stock;
                        })
                      : false;
                    if (isSetUnavailable) return <span className="text-red-600">{translate("Set is currently out of stock")}</span>;
                    if (!product.available || !product.is_in_stock) return <span className="text-red-600">{translate("Product is currently out of stock")}</span>;
                    return <Quantity id={item.cartKey || item.id} oldQty={item.qty} onHandle={ChangeQty} />;
                  })()}
                </div>
                {item.customData && (item.customData.description || item.customData.color || item.customData.date || item.customData.secondPet || (item.customData.images && item.customData.images.length > 0) || (item.customData.accessories && item.customData.accessories.length > 0) || (item.customData.customAccessories && item.customData.customAccessories.length > 0)) && (
                  <div className="mt-2 pt-2 border-t border-gray-300 max-w-full">
                    <div className="text-xs text-gray-600 space-y-1">
                      {item.customData.color && (
                        <div>{translate("Color")}: <span className="font-medium">{item.customData.color}</span></div>
                      )}
                      {item.customData.secondPet && (
                        <div>{translate("Number of pets")}: <span className="font-medium">{getPetCount(item.customData)} (+{getExtraPetsPrice(item.customData, currency).toFixed(2)} {currency})</span></div>
                      )}
                      {item.customData.accessories && item.customData.accessories.length > 0 && (
                        <div>
                          <span className="font-medium">{translate("Accessories")}:</span>
                          <div className="flex flex-wrap gap-1 mt-1">
                            {item.customData.accessories.map(id => {
                              const acc = PET_ACCESSORIES.find(a => a.id === id);
                              return acc ? (
                                <div key={id} className="relative group">
                                  {acc.image ? (
                                    <img src={acc.image} alt={getAccessoryLabel(acc, country)} title={getAccessoryDescription(acc, item.customData?.priceProfile, country)} className="w-8 h-8 object-contain rounded border border-gray-200 bg-white p-0.5" />
                                  ) : (
                                    <span title={getAccessoryDescription(acc, item.customData?.priceProfile, country)} className="w-8 h-8 flex items-center justify-center text-lg rounded border border-gray-200 bg-white">{acc.emoji}</span>
                                  )}
                                  <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-white border border-gray-200 rounded px-1.5 py-0.5 text-xs text-gray-700 whitespace-nowrap shadow">
                                    {getAccessoryLabel(acc, country)}
                                  </span>
                                </div>
                              ) : null;
                            })}
                          </div>
                        </div>
                      )}
                      {item.customData.customAccessories && item.customData.customAccessories.length > 0 && (
                        <div>
                          <span className="font-medium">{translate("Custom accessories")}:</span>
                          <ul className="mt-0.5 ml-3 list-disc">
                            {item.customData.customAccessories.map((text, i) => (
                              <li key={i}>{text}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {item.customData.description && (
                        <div className="break-words max-w-full overflow-hidden">
                          <span className="font-medium">{translate("Description")}:</span>
                          <p className="mt-1 text-gray-700 leading-relaxed">{item.customData.description}</p>
                        </div>
                      )}
                      {item.customData.date && (
                        <div>{translate("Date")}: {item.customData.date}</div>
                      )}
                      {item.customData.images && item.customData.images.length > 0 && (
                        <div className="mt-1">
                          <div className="text-xs font-medium text-gray-500 mb-1">{translate("Reference images")}:</div>
                          <div className="flex flex-wrap gap-1">
                            {item.customData.images.map((image, idx) => (
                              <img
                                key={idx}
                                src={image}
                                alt="Reference"
                                className="h-12 w-12 object-cover rounded border border-gray-300"
                              />
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      }
    })
  ));






  return (
    <div>
      <div className='h-[150px] w-full 768:h-[100px] '></div>

      <div className="w-full flex items-center sm:items-start justify-center sm:px-[10%] flex-col  sm:flex-row">
        <div className="w-[80%]">
          <div>
            <span className="font-bold text-xl">{translate("My Cart")}</span>
            <div className="w-full bg-gray-400 h-[1px] mt-3"></div>
          </div>
          <div>
            {cartItems.length === 0 ? <div className="w-full flex  justify-center items-center mt-6">{translate("Cart is empty.")}</div> : ItemsInCart}
          </div>
        </div>
        {cartItems.length === 0 || totalSubtotal < 0.01 ? "" : <div className="w-[80%] mt-12 sm:mt-0 sm:w-[400px] sm:ml-12">
          <div>
            <span className="font-bold text-xl">{translate("Order summary")}</span>
            <div className="w-full bg-gray-400 h-[1px] mt-3"></div>
          </div>

          <div className="w-full justify-between flex mt-6">
            <span>{translate("Subtotal")}</span>
            <span>{totalSubtotal} {currency}</span>
          </div>

          {/* Delivery Date Range */}
          {(() => {
            const hasPersonalMug = cartItems.some(item => {
              const p = productsData.find(pd => pd.id === item.id);
              return p && p.path?.toLowerCase().includes('personalna-ljubimac-soljica');
            });
            const hasPersonalPlate = cartItems.some(item => {
              const p = productsData.find(pd => pd.id === item.id);
              return p && p.path?.toLowerCase().includes('personalni-tanjir');
            });
            const deliveryDates = formatLeadDates(getCartLeadDays(cartItems, productsData, apiCountry));

            return (
              <div className="mt-4">
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <p className="text-xs text-gray-600">
                    {translate("Delivery within")}{' '}
                    <span className="text-gray-700">{deliveryDates.start}</span>
                    {' - '}
                    <span className="text-gray-700">{deliveryDates.end}</span>
                  </p>
                </div>
                {hasPersonalMug && (
                  <p className="text-xs text-gray-400 italic mt-1 ml-6">
                    {translate("Due to handmade production and personalization, the mug takes about 4 weeks to make.")}
                  </p>
                )}
                {hasPersonalPlate && (
                  <p className="text-xs text-gray-400 italic mt-1 ml-6">
                    {translate("Due to handmade production and personalization, the plate takes about 4 weeks to make.")}
                  </p>
                )}
              </div>
            );
          })()}

          <div className="w-full bg-gray-400 h-[1px] mt-3"></div>
          <Link to="/checkout" state={{ fromCart: true, categories: categories }}>
            <button className="w-full px-6 py-3 rounded-full font-medium transition-all duration-300 bg-darkerSkin text-white hover:bg-[#d4a76a] hover:shadow-lg mt-12 text-center">{translate("Checkout")}</button>
          </Link>

        </div>}



      </div>
      <Footer categories={categories} />
    </div>
  )
}